import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import './Legal.css';

const TermsOfService = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <div className="legal-container">
            <div className="legal-card">
                <button onClick={() => navigate(-1)} className="back-link">← {t('back', 'Voltar')}</button>
                <h1>{t('terms_of_service_title', 'Termos de Uso')}</h1>
                <p className="last-updated">{t('last_updated', 'Última atualização')}: 22 de Janeiro de 2026</p>

                <section>
                    <h2>1. Aceitação dos Termos</h2>
                    <p>Ao acessar e clicar em "Aceitar" ou utilizar o aplicativo NovaInk, você concorda em cumprir e estar vinculado a estes Termos de Uso. Se você não concordar com qualquer parte destes termos, não deverá utilizar o serviço.</p>
                </section>

                <section>
                    <h2>2. Descrição do Serviço</h2>
                    <p>O NovaInk é uma plataforma que conecta entusiastas da tatuagem a artistas profissionais. Oferecemos ferramentas para gerenciamento de orçamentos, portfólio e comunicação.</p>
                </section>

                <section>
                    <h2>3. Cadastro e Segurança</h2>
                    <p>Para utilizar certas funcionalidades, você deve criar uma conta. Você é responsável por manter a confidencialidade de sua senha e por todas as atividades que ocorrem em sua conta.</p>
                </section>

                <section>
                    <h2>4. Conduta do Usuário</h2>
                    <p>Você concorda em não utilizar o serviço para fins ilegais ou proibidos por estes termos. Conteúdo ofensivo, plágio ou comportamento inadequado resultará na suspensão imediata da conta.</p>
                </section>

                <section>
                    <h2>5. Propriedade Intelectual</h2>
                    <p>Todo o conteúdo gerado pelos artistas (fotos de tatuagens, desenhos) permanece sob sua propriedade intelectual. No entanto, ao postar no NovaInk, você concede uma licença de exibição dentro da plataforma.</p>
                </section>

                <section>
                    <h2>6. Limitação de Responsabilidade</h2>
                    <p>O NovaInk não se responsabiliza por acordos diretos entre usuários e artistas, nem por procedimentos de tatuagem realizados. Atuamos apenas como plataforma de conexão.</p>
                </section>

                <section>
                    <h2>7. Modificações</h2>
                    <p>Reservamo-nos o direito de modificar estes termos a qualquer momento. Alterações significativas serão notificadas aos usuários.</p>
                </section>
            </div>
        </div>
    );
};

export default TermsOfService;
